const eligible = 'a,button,input,select,textarea,label,summary,form,img,h1,h2,h3,h4,p,span,strong,td,th,dt,dd,[role],[aria-live]';
let sequence = 0;

// Existing explicit IDs win. Add stable per-element IDs for legacy content and
// asynchronously inserted public controls, including dropdown portals.
export const observePublicTestIds = (pathname) => {
  const route = pathname.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '') || 'home';
  const label = element => {
    if (element.hasAttribute('data-testid')) return;
    const description = element.getAttribute('id') || element.getAttribute('name') || element.getAttribute('aria-label') || element.getAttribute('role') || element.tagName || 'element';
    const key = String(description).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0,60);
    element.setAttribute('data-testid', `public-${route}-${key || 'element'}-${++sequence}`);
  };
  const visit = node => {
    if (node.nodeType !== 1) return;
    if (node.matches(eligible)) label(node);
    node.querySelectorAll(eligible).forEach(label);
  };
  visit(document.body);
  const observer = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(visit)));
  observer.observe(document.body, { childList:true, subtree:true });
  return () => observer.disconnect();
};